// @flow

// Vendors
import React from 'react';
import classnames from 'classnames';

// Types
type Props = {
  title: string,
  message: string,
  actionLabel: string,
  actionOnClick: Function,
  className?: string
};

const ItemsEmpty = ({
  title,
  message,
  actionLabel,
  actionOnClick,
  className
}: Props) => (
  <section
    className={classnames(
      'section section--lg u--text-align-center',
      className
    )}
  >
    <div className="container">
      <h2 className="u--margin-top-0">{title}</h2>
      <p>{message}</p>
      <button className="btn btn-primary" onClick={actionOnClick}>
        {actionLabel}
      </button>
    </div>
  </section>
);

export default ItemsEmpty;
